import http from "../../http";

/** 财务月汇总 — /resident/api/resident/houseFinanceMonthStat */
const BASE = "/resident/api/resident/houseFinanceMonthStat";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  rebuild(r) {
    return http.payload(`${BASE}/rebuild`, r);
  },
};
